export default {
    compress: require('./compress.png'),
    expand: require('./expand.png')
};
